var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TaskExec } from '../common/tesk-exec/task-exec';
export function memoizeAsyncify(originalMethod, input) {
    const defaultConfig = {
        cache: new Map(),
    };
    const runner = new TaskExec();
    const promCache = new Map();
    let resolvedConfig = Object.assign({}, defaultConfig);
    if (typeof input === 'number') {
        resolvedConfig.expirationTimeMs = input;
    }
    else {
        resolvedConfig = Object.assign(Object.assign({}, resolvedConfig), input);
    }
    return function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            const keyResolver = typeof resolvedConfig.keyResolver === 'string'
                ? this[resolvedConfig.keyResolver].bind(this)
                : resolvedConfig.keyResolver;
            let key;
            if (keyResolver) {
                key = keyResolver(...args);
            }
            else {
                key = JSON.stringify(args);
            }
            if (promCache.has(key)) {
                return promCache.get(key);
            }
            const prom = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                let inCache;
                try {
                    inCache = yield resolvedConfig.cache.has(key);
                }
                catch (e) {
                    reject(e);
                    return;
                }
                if (inCache) {
                    let data;
                    try {
                        data = yield resolvedConfig.cache.get(key);
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                    resolve(data);
                }
                else {
                    try {
                        const data = yield originalMethod.apply(this, args);
                        yield resolvedConfig.cache.set(key, data);
                        if (resolvedConfig.expirationTimeMs !== undefined) {
                            runner.exec(() => {
                                resolvedConfig.cache.delete(key);
                            }, resolvedConfig.expirationTimeMs);
                        }
                        resolve(data);
                    }
                    catch (e) {
                        reject(e);
                    }
                }
                promCache.delete(key);
            }));
            promCache.set(key, prom);
            return prom;
        });
    };
}
